import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import * as S from '../../../styles';
export function MediumNavigationTab(props) {
    const { selected, icon, title, onClick, data_tooltip } = props;
    const onClickAdapted = useCallback((event) => onClick(event.shiftKey), [onClick]);
    return (_jsxs(S.MediumNavigationTab, { onClick: onClickAdapted, selected: selected, "data-tooltip": data_tooltip, children: [_jsx(S.TabIcon, { children: icon }), _jsx(S.TabLabel, { label: title, children: title })] }));
}
